import { RouteInfo } from './vertical-menu.metadata';
import { pendingAppointments } from './vertical-menu-routes.config';

// Sidebar menu Routes and data
// ALWAYS FOLLOW THIS STRUCTURE SuperAdmin -> Admin -> Staff -> User
export let PULSERIGHT_ROUTES: RouteInfo[] = [
  {
    path: '/list-services',
    title: 'Hospital Services',
    icon: 'ft-briefcase',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Super Admin', 'Admin', 'Staff', 'Manager']
  },
  {
    path: '/departments',
    title: 'Departments',
    icon: 'fa-solid fa-building-user',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Admin', 'Manager']
  },
  {
    path: '/list-doctors',
    title: 'Doctors',
    icon: 'fa-solid fa-user-doctor',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Super Admin', 'Admin', 'Staff', 'Manager']
  },
  {
    path: '/doctor-queue-lists',
    title: 'My Queue List',
    icon: 'ft-book',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Doctor']
  },
  {
    path: '/doctor-appointments',
    title: 'My Appointments',
    icon: 'fa-solid fa-user-doctor',
    class: 'dropdown',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Doctor']
  },
  {
    path: '/list-patients',
    title: 'Patients',
    icon: 'ft-user-plus',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Super Admin', 'Admin', 'Staff', 'Manager', 'Doctor']
  },
  {
    path: '',
    title: 'Diagnostics',
    icon: 'fa-solid fa-microscope',
    class: 'dropdown nav-item has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '/diagnostics',
        title: 'Diagnostic Requests',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Super Admin', 'Admin', 'Staff', 'Manager', 'Doctor', 'Lab Manager', 'Laboratorist']
      },
      {
        path: '/diagnostic-templates',
        title: 'Report Templates',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Super Admin', 'Admin', 'Manager', 'Lab Manager']
      },
      {
        path: '/diagnostic-laboratory',
        title: 'Laboratory',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Super Admin', 'Admin', 'Manager', 'Lab Manager']
      },
      {
        path: '/diagnostic-settings',
        title: 'Report Settings',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Super Admin', 'Admin', 'Manager', 'Lab Manager'],
        hidden: true
      },
    ],
    category: ['Super Admin', 'Admin', 'Staff', 'Manager', 'Doctor', 'Lab Manager', 'Laboratorist']
  },
  {
    path: '',
    title: 'Appointments',
    icon: 'ft-clipboard',
    class: 'dropdown nav-item has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '/list-appointments',
        title: 'List Appointments',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown-item',
        badge: pendingAppointments,
        badgeClass: 'badge badge-pill badge-danger mt-1 mr-2 no-right',
        isExternalLink: false,
        submenu: [],
        category: ['Super Admin', 'Admin', 'Staff', 'Manager']
      },
      {
        path: '/create-appointments',
        title: 'Create Appointments',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Super Admin', 'Admin', 'Staff', 'Manager']
      },
    ],
    category: ['Super Admin', 'Admin', 'Staff', 'Manager']
  },
  {
    path: '',
    title: 'Queue Screens',
    icon: 'fa-solid fa-tv',
    class: 'dropdown nav-item has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [{
      path: '/queue-list',
      title: 'Create Screens',
      icon: 'ft-arrow-right submenu-icon',
      class: 'dropdown-item',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      category: ['Super Admin', 'Admin', 'Manager', 'Staff']
    },
    {
      path: '/operate-screen',
      title: 'Master Screen',
      icon: 'ft-arrow-right submenu-icon',
      class: 'dropdown-item',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      category: ['Super Admin', 'Admin', 'Manager', 'Staff']
    }],
    category: ['Super Admin', 'Admin', 'Staff', 'Manager']
  },
  {
    path: '',
    title: 'User Management',
    icon: 'ft-users',
    class: 'dropdown nav-item has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '/list-staff',
        title: 'List Staff',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Super Admin', 'Admin', 'Staff', 'Manager']
      },
      {
        path: '/list-lab-staff',
        title: 'List Lab Staff',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Super Admin', 'Admin', 'Manager']
      },
      {
        path: '/list-admins',
        title: 'List Managers',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Super Admin', 'Admin', 'Manager']
      },
      {
        path: '/list-super-admins',
        title: 'List Super Admins',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Super Admin', 'Admin']
      },
    ],
    category: ['Admin', 'Super Admin', 'Staff', 'Manager']
  },
  {
    path: '/list-vendors',
    title: 'Vendors',
    icon: 'ft-users',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Super Admin', 'Admin', 'Manager', 'Pharmacy Admin'],
    hidden: true
  },
  {
    path: '/payment-providers',
    title: 'Payment Providers',
    icon: 'fa-regular fa-credit-card',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Super Admin', 'Admin']
  },
  {
    path: '/immunization',
    title: 'Immunization',
    icon: 'fa-solid fa-syringe',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Super Admin', 'Admin', 'Manager']
  },
  {
    path: '/list-rooms',
    title: 'List Rooms',
    icon: 'fa-solid fa-person-booth',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Super Admin', 'Admin', 'Manager']
  },
  {
    path: '',
    title: 'Leave Tracker',
    icon: 'fa-solid fa-business-time',
    class: 'dropdown nav-item has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [{
      path: '/staff-leave',
      title: 'Apply Leave',
      icon: 'ft-arrow-right submenu-icon',
      class: 'dropdown nav-item',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      category: ['Staff', 'Manager']
    },
    {
      path: '/staff-leave-requests',
      title: 'Leave Requests',
      icon: 'ft-arrow-right submenu-icon',
      class: 'dropdown nav-item',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      category: ['Staff', 'Manager', 'Admin']
    },
    {
      path: '/staff-attendance-report',
      title: 'Attendance Report',
      icon: 'ft-arrow-right submenu-icon',
      class: 'dropdown nav-item',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      category: ['Manager', 'Admin']
    }],
    category: ['Staff', 'Manager', 'Admin']
  },
  {
    path: '/bill-generation',
    title: 'Invoice Slips',
    icon: 'fa-solid fa-credit-card',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Super Admin', 'Admin', 'Manager']
  },
  {
    path: '',
    title: 'Organization',
    icon: 'fa-solid fa-home',
    class: 'dropdown nav-item has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [{
      path: '/organization-list',
      title: 'Organization List',
      icon: 'ft-arrow-right submenu-icon',
      class: 'dropdown nav-item',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      category: ['Manager', 'Admin', 'Super Admin']
    },
    {
      path: '/organization-group',
      title: 'Organization Group',
      icon: 'ft-arrow-right submenu-icon',
      class: 'dropdown nav-item',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      category: ['Manager', 'Admin', 'Super Admin']
    }],
    category: ['Super Admin', 'Admin']
  },
  {
    path: '/modules',
    title: 'Modules',
    icon: 'fa-solid fa-list-check',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Super Admin', 'Admin']
  },
  {
    path: '',
    title: 'Pharmacies',
    icon: 'fa-solid fa-suitcase-medical',
    class: 'dropdown nav-item has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [{
      path: '/pharmacy-user-management',
      title: 'User Management',
      icon: 'ft-users',
      class: 'dropdown nav-item',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      category: ['Super Admin', 'Admin']
    },
    {
      path: '/list-pharmacy',
      title: 'List Pharmacy',
      icon: 'ft-list',
      class: 'dropdown nav-item',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [],
      category: ['Super Admin', 'Admin']
    }],
    category: ['Super Admin', 'Admin']
  },
  {
    path: '/orders',
    title: 'Orders',
    icon: 'fa-brands fa-first-order',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Pharmacy Admin']
  },
  {
    path: '/orders-history',
    title: 'Orders History',
    icon: 'fa-solid fa-clock-rotate-left',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Pharmacy Admin'],
    hidden: true
  },
  {
    path: '',
    title: 'Inventory',
    icon: 'fa-solid fa-warehouse',
    class: 'dropdown nav-item has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '/global-stocks',
        title: 'Pharmacy Products',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown nav-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Pharmacy Admin']
      },
      {
        path: '/pharmacy-stocks',
        title: 'Product Category',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown nav-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Pharmacy Admin']
      }],
    category: ['Pharmacy Admin']
  },
  {
    path: '/pharmacy-info',
    title: 'Pharmacy Info',
    icon: 'fa-solid fa-suitcase-medical',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Pharmacy Admin']
  },
  {
    path: '/pharmacy-user-management',
    title: 'Pharmacy Users',
    icon: 'ft-users',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Pharmacy Admin']
  },
  {
    path: '/prescription-template',
    title: 'Template',
    icon: 'fa-solid fa-clipboard',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Doctor']
  },
  {
    path: '/marketing',
    title: 'Marketing',
    icon: 'ft-message-square',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Admin', 'Manager', 'Super Admin']
  },
  {
    path: '',
    title: 'Pulseright Ads',
    icon: 'ft-airplay',
    class: 'dropdown nav-item has-sub',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [
      {
        path: '/campaigns',
        title: 'Campaigns',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown nav-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Admin', 'Super Admin', 'Manager']
      },
      {
        path: '/clients',
        title: 'Clients',
        icon: 'ft-arrow-right submenu-icon',
        class: 'dropdown nav-item',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        category: ['Admin', 'Super Admin', 'Manager']
      }
    ],
    category: ['Admin', 'Super Admin', 'Manager']
  },
  // {
  //   path: '/patient-bill-template',
  //   title: 'Bill Template',
  //   icon: 'ft-message-square',
  //   class: 'dropdown nav-item',
  //   badge: '',
  //   badgeClass: '',
  //   isExternalLink: false,
  //   submenu: [],
  //   category: ['Admin', 'Super Admin']
  // },
  {
    path: '/organization-settings',
    title: 'Hospital Settings',
    icon: 'fa-solid fa-gear',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Manager']
  },
  {
    path: '/settings',
    title: 'Settings',
    icon: 'fa-solid fa-gear',
    class: 'dropdown nav-item',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    category: ['Super Admin', 'Admin', 'Manager']
  }
];
